import { ca } from '@cian/analytics';

export const trackRemoveTag = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Filters',
    action: 'filter_tips_clear',
    label,
    useLastProducts: true,
  });
};

export const trackRemoveAllTags = (label: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Filters',
    action: 'filter_tips_all_clear',
    label,
    useLastProducts: true,
  });
};
